import { TransactionAccessType } from "../../../../../types/amr-pipeline/enums/TransactionAccessType";
import { CollateralQualityTest } from "../../../../../types/amr-pipeline/models/CollateralQualityTest";
import { SubscriptionFeature } from "../../../../../types/billing/SubscriptionFeature";
import {
    BlockedFeatureContent,
    SubscribeLink,
} from "../../../../access/BlockedFeatureText";
import { RequiredFeature } from "../../../../access/RequiredFeature";
import { EmptyPlaceholder, Preloader } from "../../../../common";
import { SectionContent } from "../../../common/section/SectionContent";
import { TabBody } from "../../../common/tabs/TabBody";
import { TransactionTabProps } from "../types";
import { withTabTracking } from "../withTabTracking";
import { PortolioStatisticsCharts } from "./chart/PotfolioStatisticsCharts";
import { CovenantSummaryTables } from "./CovenantSummaryTables";
import { PortfolioConcentrations } from "./PoprtfolioConcentrations/PortfolioConcentrations";

interface PortfolioStatisticsTabProps extends TransactionTabProps {
    isLoading: boolean;
}

const hasCollateralQualityTestsData = (tests?: CollateralQualityTest[]) =>
    tests != null &&
    tests.length > 0 &&
    tests.some(test => test.covenant != null || test.target != null);

const PortfolioStatisticsTab = ({
    transaction,
    difference,
    isLoading,
}: PortfolioStatisticsTabProps) => {
    if (isLoading) return <Preloader inProgress={true} />;

    const hasCovenantSummaryData = hasCollateralQualityTestsData(transaction.collateralQualityTests);
    if (!hasCovenantSummaryData && !transaction.portfolio?.length) {
        return <EmptyPlaceholder text="There is no portfolio statistics to display." />;
    }

    return (
        <TabBody className="tabs-data-padding component-tabs-portfolio-statistics">
            <RequiredFeature
                feature={SubscriptionFeature.IssuanceMonitorFullAccess}
                renderBlockedContent={() => (
                    <BlockedFeatureContent
                        inline
                        className="empty-placeholder"
                        text={<><SubscribeLink /> to see Portfolio Statistics.</>}
                    />
                )}
            >
                {!difference && transaction.portfolio?.length > 0 &&
                    <>
                        <SectionContent title="">
                            <PortfolioConcentrations
                                items={transaction.portfolio}
                            />
                        </SectionContent>
                        {/* Render Facility Rating Distribution only if there are charts to display */}
                        <PortolioStatisticsCharts portfolio={transaction.portfolio}>
                            {content =>
                                <SectionContent title="Facility Rating Distribution" className="facility-rating-distribution">
                                    {content}
                                </SectionContent>
                            }
                        </PortolioStatisticsCharts>
                    </>
                }
                {hasCovenantSummaryData &&
                    <SectionContent>
                        <CovenantSummaryTables
                            items={transaction.collateralQualityTests}
                            difference={difference?.collateralQualityTests}
                        />
                    </SectionContent>
                }
            </RequiredFeature>
        </TabBody >
    );
};

export const PortfolioStatistics = withTabTracking(
    TransactionAccessType.PortfolioStatistics
)(PortfolioStatisticsTab);
